import { MyPageAssetModule } from "~/components/Modules/MyPage/MyPageAssetModule";
import { MyPageHistoryModule } from "~/components/Modules/MyPage/MyPageHistoryModule";
import { MyPageJoinedFandomsModule } from "~/components/Modules/MyPage/MyPageJoinedFandomsModule";
import { MyPageTopBarModule } from "~/components/Modules/MyPage/MyPageTopBarModule";
import { MyPageUserProfileModule } from "~/components/Modules/MyPage/MyPageUserProfileModule";

type Props = {
  myPageTopBarProps: React.ComponentProps<typeof MyPageTopBarModule>;
  myPageUserProfileProps: React.ComponentProps<typeof MyPageUserProfileModule>;
  myPageJoinedFandomsProps: React.ComponentProps<
    typeof MyPageJoinedFandomsModule
  >;
  myPageAssetProps: React.ComponentProps<typeof MyPageAssetModule>;
  myPageHistoryProps: React.ComponentProps<typeof MyPageHistoryModule>;
};

export const MyPageTemplate = (props: Props) => {
  return (
    <>
      <MyPageTopBarModule {...props.myPageTopBarProps} />
      <div className="flex min-h-full flex-col items-center gap-[16px] bg-white py-[30px] pb-[66px]">
        <MyPageUserProfileModule {...props.myPageUserProfileProps} />
        <MyPageJoinedFandomsModule {...props.myPageJoinedFandomsProps} />
        <MyPageAssetModule {...props.myPageAssetProps} />
        <MyPageHistoryModule {...props.myPageHistoryProps} />
      </div>
    </>
  );
};
